import type { ApplicationSummary } from '../dtos/application';

export class Application {
  readonly id: string;
  readonly applicationGuid: string;
  readonly name: string;
  readonly companyName: string;
  readonly spread: number | null;
  readonly phoneNumber: string;
  readonly amount: number | null;
  readonly status: string;

  constructor(params: Partial<Application> & { applicationGuid?: string }) {
    this.applicationGuid = params.applicationGuid ?? '';
    this.id = this.applicationGuid;
    this.name = params.name ?? '';
    this.companyName = params.companyName ?? '';
    this.spread = params.spread ?? null;
    this.phoneNumber = params.phoneNumber ?? '';
    this.amount = params.amount ?? null;
    this.status = params.status ?? '';
  }

  /** Searchable text for table filtering (legacy delimiter avoids partial field matches). */
  filterText(): string {
    const parts = [
      this.applicationGuid,
      this.name,
      this.companyName,
      this.phoneNumber,
      this.amount != null ? `$${this.amount}` : '',
      this.spread != null ? `${this.spread}%` : '',
      this.status,
    ];
    return parts.join('█').toLowerCase();
  }
}

export const ApplicationMapper = {
  fromDto(dto: ApplicationSummary): Application {
    return new Application({
      applicationGuid: dto.applicationGuid,
      name: dto.name,
      companyName: dto.companyName,
      spread: dto.spread,
      phoneNumber: dto.phoneNumber,
      amount: dto.amount,
      status: dto.status,
    });
  },

  fromDtoList(dtos: ApplicationSummary[]): Application[] {
    return (dtos ?? []).map((dto) => ApplicationMapper.fromDto(dto));
  },
};
